import moment from "moment";
import { Slide, toast } from "react-toastify";
import Cookies from "js-cookie";
import pushNotification from "./util";

export const deleteDataByAdviceType = (data: any, adviceType: any, deletedTradeUniqueId: any) => {
  return data?.filter((item: any) => item?.unique_id !== deletedTradeUniqueId)
}

export const handleNotificationStatus = (code: any, modelNotifStatus: any) => {
  let modelCodeNotification: any = true;
  console.log("Handle notify before modify status :", modelNotifStatus)
  // Iterate over the array directly
  modelNotifStatus.forEach((item: any) => {
    if (item?.s_code === code) {
      modelCodeNotification = item?.s_notificationenabled === "true"; // Convert string to boolean
    }
  });
  console.log("Handle notify after modify status :", modelNotifStatus, "model :",modelCodeNotification)

  return modelCodeNotification;
}

//insertion notification
export const notifyInsert = (data: any) => {
  toast.success(
    `${data?.s_code}, trade generated at ${data?.dt_entry_time}`,
    {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Slide,
    }
  );
  pushNotification(`${data?.s_code}, New trade generated at ${data?.dt_entry_time}`)
}



export const columns: any = [
  { field: "s_symbol", header: "Symbol" },
  { field: "s_code", header: "Code" },
  { field: "dt_date", header: "Open Date" },
  { field: "dt_entry_time", header: "Open Time" },
  { field: "dt_exit_time", header: "Close Time" },
  { field: "s_trade_type", header: "Trade Type" },
  { field: "n_transaction", header: "Transaction" },
  { field: "n_exit_price", header: "LTP" },
  { field: "s_status", header: "Status" },
  { field: "n_return", header: "Return(%)" },
  { field: "n_return_after_cost", header: "Return After Cost (%)" },
  { field: "n_pl", header: "P/L" },
  { field: "n_pl_rs", header: "P/L (₹)" }
];
//New added for back dated column
export const backdatedColumns: any = [
  { field: "asset", header: "Symbol" },
  { field: "identifier", header: "Code" },
  { field: "open_date", header: "Open Date" },
  { field: "dt_open_time", header: "Open Time" },
  { field: "dt_end_time", header: "Close Time" },
  { field: "trade_type", header: "Trade Type" },
  { field: "n_open_transaction_price", header: "Transaction" },
  { field: "exit_price", header: "LTP" },
  { field: "s_reason", header: "Status" },
  { field: "return_per", header: "Return(%)" },
  { field: "return_after_cost", header: "Return After Cost (%)" },
  { field: "trade_pl_rs", header: "P/L (₹)" },
  { field: "trade_pl", header: "P/L" }
];
export const equity_columns: any = [
  { field: "s_symbol", header: "Symbol" },
  { field: "s_code", header: "Code" },
  { field: "dt_date", header: "Open Date" },
  { field: "dt_close_date", header: "Close Date" },
  { field: "dt_entry_time", header: "Open Time" },
  { field: "dt_exit_time", header: "Close Time" },
  { field: "s_trade_type", header: "Trade Type" },
  { field: "n_transaction", header: "Transaction" },
  { field: "n_exit_price", header: "LTP" },
  { field: "s_status", header: "Status" },
  { field: "n_return", header: "Return(%)" },
  { field: "n_return_after_cost", header: "Return After Cost (%)" },
  { field: "n_pl", header: "P/L" },
  { field: "n_pl_rs", header: "P/L (₹)" },
  // { field: "pl_with_dividend", header: "P/L (Exclusive of Dividend)" },
  { field: "oneDayPl", header: "1D P/L" },
  { field: "oneDay_return_per", header: "1D Return(%)" }
];

export const backdatedEquityColumns: any = [
  { field: "asset", header: "Symbol" },
  { field: "identifier", header: "Code" },
  { field: "open_date", header: "Open Date" },
  { field: "trade_close_date", header: "Close Date" },
  { field: "dt_open_time", header: "Open Time" },
  { field: "dt_end_time", header: "Close Time" },
  { field: "trade_type", header: "Trade Type" },
  { field: "n_open_transaction_price", header: "Transaction" },
  { field: "exit_price", header: "LTP" },
  { field: "s_reason", header: "Status" },
  { field: "return_per", header: "Return(%)" },
  { field: "return_after_cost", header: "Return After Cost (%)" },
  { field: "trade_pl", header: "P/L" },
  { field: "trade_pl_rs", header: "P/L (₹)" },
  // { field: "pl_without_dividend", header: "P/L (Exclusive of Dividend)" },
  { field: "oneDaypl", header: "1D P/L" },
  { field: "oneDay_return_per", header: "1D Return(%)" }
];

export const equityN50_columns: any = [
  { field: "s_symbol", header: "Symbol" },
  { field: "s_code", header: "Code" },
  { field: "dt_date", header: "Open Date" },
  { field: "dt_close_date", header: "Close Date" },
  { field: "dt_entry_time", header: "Open Time" },
  { field: "dt_exit_time", header: "Close Time" },
  { field: "s_trade_type", header: "Trade Type" },
  { field: "n_transaction", header: "Transaction" },
  { field: "n_exit_price", header: "LTP" },
  { field: "s_status", header: "Status" },
  { field: "n_return", header: "Return(%)" },
  { field: "n_return_after_cost", header: "Return After Cost (%)" },
  { field: "n_pl", header: "P/L" },
  { field: "n_pl_rs", header: "P/L (₹)" },
  { field: "oneDayPl", header: "1D P/L" },
  { field: "oneDay_return_per", header: "1D Return(%)" }
];

export const backdatedEquityN50Columns: any = [
  { field: "asset", header: "Symbol" },
  { field: "identifier", header: "Code" },
  { field: "open_date", header: "Open Date" },
  { field: "trade_close_date", header: "Close Date" },
  { field: "dt_open_time", header: "Open Time" },
  { field: "dt_end_time", header: "Close Time" },
  { field: "trade_type", header: "Trade Type" },
  { field: "n_open_transaction_price", header: "Transaction" },
  { field: "exit_price", header: "LTP" },
  { field: "s_reason", header: "Status" },
  { field: "return_per", header: "Return(%)" },
  { field: "return_after_cost", header: "Return After Cost (%)" },
  { field: "trade_pl", header: "P/L" },
  { field: "trade_pl_rs", header: "P/L (₹)" },
  { field: "oneDaypl", header: "1D P/L" },
  { field: "oneDay_return_per", header: "1D Return(%)" }
];

export const optLong_columns: any = [
  { field: "s_symbol", header: "Symbol" },
  { field: "s_code", header: "Code" },
  { field: "dt_date", header: "Open Date" },
  { field: "dt_entry_time", header: "Open Time" },
  { field: "dt_exit_time", header: "Close Time" },
  { field: "s_trade_type", header: "Trade Type" },
  { field: "n_transaction", header: "Transaction" },
  { field: "n_exit_price", header: "LTP" },
  { field: "s_status", header: "Status" },
  { field: "n_return", header: "Return(%)" },
  { field: "n_return_after_cost", header: "Return After Cost (%)" },
  { field: "n_pl", header: "P/L" },
  { field: "n_pl_rs", header: "P/L (₹)" }

];
export const backdatedOptLongColumns: any = [
  { field: "asset", header: "Symbol" },
  { field: "identifier", header: "Code" },
  { field: "open_date", header: "Open Date" },
  { field: "dt_open_time", header: "Open Time" },
  { field: "dt_end_time", header: "Close Time" },
  { field: "trade_type", header: "Trade Type" },
  { field: "n_open_transaction_price", header: "Transaction" },
  { field: "exit_price", header: "LTP" },
  { field: "s_reason", header: "Status" },
  { field: "return_per", header: "Return(%)" },
  { field: "return_after_cost", header: "Return After Cost (%)" },
  { field: "trade_pl", header: "P/L" },
  { field: "trade_pl_rs", header: "P/L (₹)" }
];

export const privilegeChecking = (data:any) => {
  
  //Fetching the model privileges from the cookies
  let cookiesCodesArr: any = Cookies.get('codesArray') || []
  
  if (!(JSON.parse(cookiesCodesArr)?.includes(data?.s_code?.slice(0, -1)))) return;

  // Notification is enabled or not
  let notificationEnabledValue: any = localStorage.getItem('notificationEnabled') ? localStorage.getItem('notificationEnabled') : JSON.stringify(false);
  let isLoggedInDetails: any = Cookies.get('details') ? Cookies.get('details') : JSON?.stringify({ 'isLoggedIn': false })
  let userLoggedIn: any = JSON.parse(isLoggedInDetails)['isLoggedIn']
  
  //Checking the user have access or not
  if (JSON.parse(notificationEnabledValue) === true && userLoggedIn === true) {
    return true
  }
  else {
    return false
  }

}

export const checkingDateIsToday:any = (selectedDate:any) => {
   if(selectedDate !== moment(new Date()).format('YYYY-MM-DD')){
    return false
   }else{
    return true
   }
}

export const formattingDate = (date: string, format = "MMM DD, YYYY") => moment(date).format(format);

export const getStatusFormattedDate = (status: string, date: string) => (
  status.toUpperCase() === 'OPEN' ? '' : formattingDate(date)
);

export const formatExitPrice = (obj: any) => (
  obj.n_exit_price === null ? "" : (obj?.s_code === 'AIONIFKKI' ? Number(obj?.n_exit_price)?.toFixed(2) : Number(obj.n_exit_price)?.toFixed(2))
);

export const getStatusExitTime = (status: string, exitTime: string) => (
  (status.toUpperCase() !== 'OPEN' && status !== '') ? exitTime : ''
);

export const calculatePLWithDividend = (obj: any) => (
  obj?.j_dividend?.length > 0 ? Number(obj?.n_pl + Number(obj?.pl_with_dividend)) : Number(obj?.n_pl)
);

export const mapTargetStoploss = (obj: any) => (

  Object?.keys(obj?.j_target_stoploss)?.map((item: any) => {
    const target = item?.Target;
    const stoploss = item?.Stoploss;
    const mappedItem: any = {
      s_symbol: obj.s_symbol,
      s_code: obj.s_code,
      time: item?.time,
    };
    if (target) mappedItem.Target = target;
    if (stoploss) mappedItem.Stoploss = stoploss;
    return mappedItem;
  })
);


export const filterTrades = (trades: any, type: string) => {
    switch (type) {
      case "FNO":
        return trades?.filter(
          (item: any) => !["AIOBANDDIS", "AIONIFDDIS"].includes(item?.s_code) && !item?.s_code.startsWith("QEB") && ((item?.s_code)?.slice(0,-1) !== "AIONIFKKI") && (item?.s_code.slice(1, 3) !== "ES"));
      case "LFT":
        return trades?.filter((item: any) => ["AIONIFDDIS", "AIOBANDDIS"]?.includes(item?.s_code));
      case "EQ":
        return trades?.filter((item: any) => (item?.s_code?.slice(1, 3) === "ES"));
      case "EqN50":
        return trades?.filter((item: any) => (item?.s_code?.startsWith("QEB")));
      case "OptLong":
        return trades?.filter((item: any) => (item?.s_code?.slice(0, -1) === "AIONIFKKI"));
      default:
        return trades;
    }
  };


  export const setMapper:any = {
    'FNO' : {
      'live' : 'setFilteredFNOData',
      'backdated' : 'setBackdatedFilteredFNOData'
    },
    'LFT' : {
      'live' : 'setFilteredLFTData',
      'backdated' : 'setBackdatedFilteredLFTData'
    },
    'EQ'  : {
      'live' : 'setFilteredEQData',
      'backdated' : 'setBackdatedFilteredEQData'
    },
    'EqN50plus' : {
      'live' : 'setFilteredEqN50Data',
      'backdated' : 'setBackdatedFilteredEqN50Data'
    },
    'OPT LONG'  : {
      'live' : 'setFilteredOptLongData',
      'backdated' : 'setBackdatedFilteredOptLongData'
    },

  }